import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useHasMultipleEntities } from '@/entities/boat';
import { navigationList } from '@/entities/navigation/model/constants/navigation-list';
import { useRoutes } from '@/entities/navigation/model/hooks/use-routes.hook';
import { useAutomatedPlanAccess, useIsPlant, useMultiI18nKeys } from '@/entities/user';
import { Box } from '@/shared/ui/box';

import { NavigationLink } from '../navigation-link';
import * as Styled from './navigation-menu.styles';
import { NavigationMenuProps } from './navigation-menu.types';

const NavigationMenuComponent = ({ collapsed, close }: NavigationMenuProps) => {
	const { t } = useTranslation('common');
	const isPlant = useIsPlant();
	const automatedPlanAccess = useAutomatedPlanAccess();
	const hasMultipleEntities = useHasMultipleEntities();
	const dynamicRoutes = useRoutes();
	const keys = useMultiI18nKeys();

	return (
		<Box direction="column" gap={12}>
			{navigationList.map(({ dynamicTitle, routes, title }, index) => {
				const label = dynamicTitle?.(isPlant) ?? title;

				return (
					<Box key={`${label}_${index}`} direction="column" gap={16}>
						{!collapsed && label && <Styled.SectionTitle label={t(label)} weight={600} size="xs" />}
						<Box direction="column" gap={4}>
							{routes
								.filter(({ canShow }) => (canShow ? canShow(isPlant, hasMultipleEntities, automatedPlanAccess) : true))
								.map(({ dynamicHref, dynamicLabel, dynamicSvg, href, label, Svg }) => {
									const route = dynamicHref?.(dynamicRoutes) ?? href;
									const i18nKey = dynamicLabel?.(keys) || label;
									const svg = dynamicSvg?.(isPlant) || Svg;

									return (
										<NavigationLink
											key={i18nKey}
											close={close}
											label={i18nKey}
											collapsed={collapsed}
											href={route}
											Svg={svg}
										/>
									);
								})}
						</Box>
					</Box>
				);
			})}
		</Box>
	);
};

export default memo(NavigationMenuComponent);
